<script>
  import { checkbox } from 'vue-strap';
  import MateriaisDeConsumo from './FormMateriaisDeConsumo.vue';
  import Livros from './FormLivros.vue';
  import Equipamentos from './FormEquipamentos.vue';
  import ContratacaoDeServicos from './FormContratacaoDeServicos.vue';
  import LocacaoDeVeiculos from './FormLocacaoDeVeiculos.vue';
  import ReservaDeHotel from './FormReservaDeHotel.vue';
  import Importacao from './FormImportacao.vue';
  import ComprasOnline from './FormComprasOnline.vue';
  import ComprasInternas from './FormComprasInternas.vue';
  import PassagemAerea from './FormPassagemAerea.vue';
  import projetoServico from '~modulos/projeto/servico';
  import formatarData from '~js/formatar-data';
  import solicitacaoCompraServico from '../../servico';

  export default {
    components: {
      checkbox,
      MateriaisDeConsumo,
      Livros,
      Equipamentos,
      ContratacaoDeServicos,
      LocacaoDeVeiculos,
      ReservaDeHotel,
      Importacao,
      ComprasOnline,
      ComprasInternas,
      PassagemAerea
    },
    props: {
      itensSolicitacaoCompra: {
        type: Array,
        default: []
      },
      projeto: Object,
    },
    data() {
      return {
        manterJustificativa: false,
        manterObservacao: false,
        desabilitarExecutora: false,
        manterMetaEtapaRubricaSubrubrica: false,
        manterLocalAlocado: false,
        configuracao: this.$storage.configuracao(),
        itemSolicitacao: this.camposItemSolicitacao(),
        indice: -1,
        auxIDSubRubrica: 0,
        metaEtapas: [],
        rubricas: [],
        subrubricas: [],

        produtos: [],
        tiposProdutos: [],

        tipoItemCompra: this.$storage.tipoItemCompra(),
      }
    },
    methods: {
      validar() {
        const validacoes = [
          this.$validator.validateAll()
        ];

        switch (this.itemSolicitacao.tipoCompra) {
          case '':
          case '01':
            validacoes.push(this.$refs.materiaisDeConsumo.validar());
            break;
          case '04':
            validacoes.push(this.$refs.livros.validar());
            break;
          case '05':
            validacoes.push(this.$refs.equipamentos.validar());
            break;
          case '06':
            validacoes.push(this.$refs.contratacaoDeServicos.validar());
            break;
          case '06b':
            validacoes.push(this.$refs.locacaoDeVeiculos.validar());
            break;
          case '09':
            validacoes.push(this.$refs.reservaDeHotel.validar());
            break;
          case '10':
            validacoes.push(this.$refs.importacao.validar());
            break;
          case '13':
            validacoes.push(this.$refs.comprasOnline.validar());
            validacoes.push(this.$refs.comprasOnline.validarCustomizado());
            break;
          case '14':
            validacoes.push(this.$refs.comprasInternas.validar());
            break;
          case '15':
            validacoes.push(this.$refs.passagemAerea.validar());
            break;
        }

        Promise.all(validacoes)
          .then(valido => {
            if (valido.find(x => x === false) === undefined) {
              this.adicionar();
            }
          });
      },
      async adicionar() {
        const copiaItem = Object.assign(this.itemSolicitacao);

        if (copiaItem.voltagem === '0') copiaItem.voltagem = '';

        if (copiaItem.idProjetoMetaEtapa) {
          this.metaEtapas.map(projetoMetaEtapa => {
            if (projetoMetaEtapa.idProjetoMetaEtapa === copiaItem.idProjetoMetaEtapa) {
              copiaItem.projetoMetaEtapa = projetoMetaEtapa;
            }
          });
        }

        if (copiaItem.idRubrica) {
          copiaItem.rubrica = this.rubricas.find(rubrica => rubrica.id == copiaItem.idRubrica);
        }
        if (copiaItem.idSubrubrica) {
          copiaItem.subrubrica = this.subrubricas.find(subrubrica => subrubrica.id == copiaItem.idSubrubrica);
        }

        if (copiaItem.idProduto) {
          copiaItem.produto = this.produtos.find(produto => produto.idProduto == copiaItem.idProduto);
        }

        if (copiaItem.idTipoProduto) {
          copiaItem.tipoProduto = this.tiposProdutos.find(tipoProduto => tipoProduto.idTipoProduto == copiaItem.idTipoProduto);
        }

        if (copiaItem.validadeCnh) {
          copiaItem.validadeCnh = await formatarData.paraNumero(copiaItem.validadeCnh);
        }
        if (copiaItem.dataNascimento) {
          copiaItem.dataNascimento = await formatarData.paraNumero(copiaItem.dataNascimento);
        }
        if (copiaItem.dataCheckin) {
          copiaItem.dataCheckin = await formatarData.paraNumero(copiaItem.dataCheckin);
        }
        if (copiaItem.dataCheckout) {
          copiaItem.dataCheckout = await formatarData.paraNumero(copiaItem.dataCheckout);
        }

        if (copiaItem.dataIda) {
          copiaItem.dataIda = await formatarData.paraNumero(copiaItem.dataIda);
        }
        if (copiaItem.dataVolta) {
          copiaItem.dataVolta = await formatarData.paraNumero(copiaItem.dataVolta);
        }

        if (copiaItem.apenasIda === 'true')
          copiaItem.apenasIda = true;
        else
          copiaItem.apenasIda = false;

        if (copiaItem.contrato === 'true')
          copiaItem.contrato = true
        else
          copiaItem.contrato = false

        if (copiaItem.aditivo === 'true')
          copiaItem.aditivo = true
        else
          copiaItem.aditivo = false


        if (this.indice > -1) {
          this.itensSolicitacaoCompra.splice(this.indice, 1);         
          copiaItem.idItemSolicitacaoCompra = 0;
          this.itensSolicitacaoCompra.splice(this.indice, 0, copiaItem);
          this.indice = -1;
        }
        else
          this.itensSolicitacaoCompra.push(copiaItem);

        this.limparCamposItemSolicitacao();

        if (this.manterJustificativa) {
          this.$set(this.itemSolicitacao, 'objetivoCompra', copiaItem.objetivoCompra)
        }

        if (this.manterLocalAlocado) {
          this.$set(this.itemSolicitacao, 'localAlocado', copiaItem.localAlocado)
        }

        if (this.manterObservacao) {
          this.$set(this.itemSolicitacao, 'observacaoItemCompra', copiaItem.observacaoItemCompra)
        }

        if (this.manterMetaEtapaRubricaSubrubrica) {
          if (this.projeto.utilizarMetaEtapaProjeto) {
            this.$set(this.itemSolicitacao, 'idProjetoMetaEtapa', copiaItem.idProjetoMetaEtapa);
            this.$set(this.itemSolicitacao, 'projetoMetaEtapa', copiaItem.projetoMetaEtapa);
          }
          if (this.configuracao.exibirRubricaSubrubricaSolicitacaoWeb || this.projeto.utilizarRubricaSubrubricaWeb) {
            this.$set(this.itemSolicitacao, 'idRubrica', copiaItem.idRubrica);
            this.$set(this.itemSolicitacao, 'idSubrubrica', copiaItem.idSubrubrica);
            this.$set(this.itemSolicitacao, 'rubrica', copiaItem.rubrica);
            this.$set(this.itemSolicitacao, 'subrubrica', copiaItem.subrubrica);
          }
        } else {
          this.subrubricas = [];
        }

        if (this.configuracao.permitirApenasUmTipoItemSolicitacaoCompra) {
          this.$set(this.itemSolicitacao, 'tipoCompra', copiaItem.tipoCompra);
        }

        this.setDesabilitarExecutora(this.itensSolicitacaoCompra);

        this.$validator.reset();
        $('#tabs a[href="#tab-itens-solicitacao"]').tab('show');
      },
      limparCamposItemSolicitacao(completo = true) {
        const campos = this.camposItemSolicitacao();

        // if (!completo) {
        //   campos.tipoCompra = this.itemSolicitacao.tipoCompra;
        // }

        this.$set(this, 'itemSolicitacao', campos);
      },
      carregarMetaEtapas(idProjeto) {
        projetoServico
          .metaEtapas(idProjeto)
          .then(metaEtapas => {
            this.metaEtapas = metaEtapas;
          });
      },
      carregarRubricas(idProjeto) {
        if (this.indice == -1)
          this.itemSolicitacao.idSubrubrica = '';

        this.itemSolicitacao.idRubrica = '';

        projetoServico
          .rubricas(idProjeto)
          .then(rubricas => {
            this.rubricas = rubricas;
          });
      },
      carregarSubrubricas() {
        if (this.indice == -1)
          this.itemSolicitacao.idSubrubrica = '';

        if (!this.itemSolicitacao.idRubrica) {
          this.subrubricas = [];
          return;
        }

        projetoServico
          .subrubricas(this.projeto.idProjeto, this.itemSolicitacao.idRubrica)
          .then(subrubricas => {
            this.subrubricas = subrubricas;

            if (this.indice > -1) { 
              if (this.auxIDSubRubrica) {
                this.$set(this.itemSolicitacao, 'idSubrubrica', this.auxIDSubRubrica);

                let auxSub = this.subrubricas.find(subrubrica => subrubrica.id == this.auxIDSubRubrica);

                if (auxSub) 
                  this.$set(this.itemSolicitacao, 'subrubrica', auxSub);
              }
            }
          });
      },
      camposItemSolicitacao() {
        return {
          item: '',
          quantidade: '',
          unidade: '',
          descricao: '',
          idProduto: '',
          idTipoProduto: '',
          quantidadeNova: '',
          complementoNovo: '',
          idCompra: '',
          idProjetoItemControle: '',
          idUsuario: '',
          dataCancelamento: '',
          observacaoCancelamento: '',
          valorEstimado: '',
          controleTermico: '',
          fragil: '',
          solventeReagente: '',
          inflamavel: '',
          toxico: '',
          vivoPerecivel: '',
          idRubrica: '',
          idSubrubrica: '',
          idRubricaEnvio: '',
          idSubRubricaEnvio: '',
          controleTermicoNovo: '',
          fragilNovo: '',
          solventeReagenteNovo: '',
          inflamavelNovo: '',
          toxicoNovo: '',
          vivoPerecivelNovo: '',
          naoSeAplica: '',
          objetivoCompra: '',
          observacaoItemCompra: '',
          idProjetoMetaEtapa: '',
          iunidade: '',
          liberado: '',
          idLicitacao: '',
          dataHoraLiberacao: '',
          dataHoraLiberacaoCoord: '',
          dataHoraCancelamento: '',
          idUsuarioCancelamento: '',
          isbn: '',
          autor: '',
          editora: '',
          edicao: '',
          volume: '',
          exemplar: '',
          nomeMotorista: '',
          cnh: '',
          validadeCnh: '',
          dataNascimento: '',
          nomePrestador: '',
          emailPrestador: '',
          telefonePrestador: '',
          nomeHospede: '',
          cpfHospede: '',
          emailHospede: '',
          telefoneHospede: '',
          nomeHotel: '',
          dataCheckin: '',
          horaCheckin: '',
          dataCheckout: '',
          horaCheckout: '',
          despesasExtras: '',
          controladoPoliciaFederal: '',
          controladoExercito: '',
          nomeTecnicoResponsavel: '',
          nrRegistroConselho: '',
          localArmazenagem: '',
          finalidadeUsoProduto: '',
          voltagem: '',
          nomeEmpresa: '',
          responsavel: '',
          emailResponsavel: '',
          telefoneResponsavel: '',
          nomeExportador: '',
          responsavelExportador: '',
          emailExportador: '',
          telefoneExportador: '',
          proformaInvoice: '',
          vencProformaInvoice: '',
          despesaCapital: '',
          materialConsumo: '',
          outros: '',
          tipoCompra: '',
          naoPatrimoniavel: '',
          projetoMetaEtapa: null,
          rubrica: null,
          subrubrica: null,
          localAlocado: '',
          contrato: '',
          aditivo: '',
          enderecoLocalAlocado: '',
          numeroLocalAlocado: '',
          complementoLocalAlocado: '',
          bairroLocalAlocado: '',
          cidadeLocalAlocado: '',
          estadoLocalAlocado: '',
          cepLocalAlocado: '',
          unidadeLocalAlocado: '',
          cnpjUnidadeLocalAlocado: '',
          executora: '',
          origemIda: '',
          destinoIda: '',
          dataIda: '',
          horarioIda: '',
          horarioChegadaIda: '',
          origemVolta: '',
          destinoVolta: '',
          dataVolta: '',
          horarioVolta: '',
          horarioChegadaVolta: '',
          apenasIda: 'false',
        }
      },
      alterarProduto() {
        this.itemSolicitacao.idTipoProduto = '';
        this.itemSolicitacao.idProduto = '';
        this.produtos = [];
        this.listaDeTiposProdutos();
      },
      habilitarTipoCompra(tipo) {
        if (!this.configuracao.habilitarTiposCompraPorProjeto) {
          switch (tipo) {
            case "10":
              return false;
              break;
            case "13":
              return false;
              break;
            case "14":
              return false;
              break;
            case "15":
              return false;
              break;
            default:
              return true;
              break;
          }
        }

        if (this.tipoItemCompra > 0){
            if (this.tipoItemCompra == 1)
                if (tipo == "13")
                    return false;

            if (this.tipoItemCompra == 2)
                if (tipo != "13")
                    return false;
        }

        switch (tipo) {
          case "01":
            return this.projeto.habilitarMateriaisConsumo;
            break;
          case "04":
            return this.projeto.habilitarLivros;
            break;
          case "05":
            return this.projeto.habilitarEquipamentos;
            break;
          case "06":
            return this.projeto.habilitarContratacoesServico;
            break;
          case "06b":
            return this.projeto.habilitarLocacaoVeiculo;
            break;
          case "09":
            return this.projeto.habilitarReservaHotel;
            break;
          case "10":
            return this.projeto.habilitarImportacao;
            break;
          case "13":
            return this.projeto.habilitarComprasOnline;
            break;
          case "14":
            return this.projeto.habilitarComprasInternas;
            break;
          case "15":
            return this.projeto.habilitarPassagemAerea;
            break;
          default:
            return true;
            break;
        }
      },
      listaDeProdutos() {
        if (this.itemSolicitacao.idTipoProduto == '') {
          this.produtos = [];
          return;
        }

        if (this.itemSolicitacao.tipoCompra == '') {
          this.produtos = [];
          return;
        }

        return solicitacaoCompraServico
          .produtosCompra(this.itemSolicitacao.idTipoProduto, this.itemSolicitacao.tipoCompra)
          .then(produtos => {
            this.produtos = produtos;
          });
      },
      listaDeTiposProdutos() {
        if (!this.configuracao.obrigatorioSelecionarProduto){
          this.tiposProdutos = [];
          return;
        }

        if (this.itemSolicitacao.tipoCompra == '') {
          this.tiposProdutos = [];
          return;
        }

        return solicitacaoCompraServico
          .tiposProdutosCompra(this.itemSolicitacao.tipoCompra)
          .then(tiposProdutos => {
            this.tiposProdutos = tiposProdutos;
          });
      },
      setDesabilitarExecutora(itens) {
            let item = itens.find(i => i.tipoCompra == '13')

            if (this.indice > -1)
              if (itens.length == 1)
                item = null;

            if (item) {
                this.$set(this.itemSolicitacao, 'executora', item.executora);
                this.$set(this.itemSolicitacao, 'projetoAceitarRetirarMercadoria', item.projetoAceitarRetirarMercadoria);
                this.$set(this.itemSolicitacao, 'projetoAceitarVariacaoPreco', item.projetoAceitarVariacaoPreco);
                this.$set(this.itemSolicitacao, 'projetoAceitarFrete', item.projetoAceitarFrete);
                this.$set(this.itemSolicitacao, 'observacaoItemCompra', item.observacaoItemCompra);
                this.$set(this.itemSolicitacao, 'percentualVariacaoValor', item.percentualVariacaoValor);
                this.$set(this.itemSolicitacao, 'percentualVariacaoFrete', item.percentualVariacaoFrete);
                this.desabilitarExecutora = item.executora != '';
                return;
            } 

            this.desabilitarExecutora = false;
            this.$set(this.itemSolicitacao, 'executora', "");
            this.$set(this.itemSolicitacao, 'projetoAceitarRetirarMercadoria', "");
            this.$set(this.itemSolicitacao, 'projetoAceitarVariacaoPreco', "");
            this.$set(this.itemSolicitacao, 'projetoAceitarFrete', "");
            this.$set(this.itemSolicitacao, 'observacaoItemCompra', "");
            this.$set(this.itemSolicitacao, 'percentualVariacaoValor', "");
            this.$set(this.itemSolicitacao, 'percentualVariacaoFrete', "");
      },
      async editarItem(item, indice) {
        if (item.contrato)
          item.contrato = 'true'
        else
          item.contrato = 'false'

        if (item.aditivo)
          item.aditivo = 'true'
        else
          item.aditivo = 'false'

        if (item.voltagem)
          item.voltagem = item.voltagem.toString();

        if (item.validadeCnh) {
          item.validadeCnh = await formatarData.paraData(item.validadeCnh);
        }
        else
          item.validadeCnh = '';


        if (item.dataNascimento) {
          item.dataNascimento = await formatarData.paraData(item.dataNascimento);
        }
        else
          item.dataNascimento = '';

        if (item.dataCheckin) {
          item.dataCheckin = await formatarData.paraData(item.dataCheckin);
        }
        else
          item.dataCheckin;


        if (item.dataCheckout) {
          item.dataCheckout = await formatarData.paraData(item.dataCheckout);
        }
        else
          item.dataCheckout

        if (item.dataIda) {
          item.dataIda = await formatarData.paraData(item.dataIda);
        }
        else
          item.dataIda = '';

        if (item.dataVolta) {
          item.dataVolta = await formatarData.paraData(item.dataVolta);
        }
        else
          item.dataVolta = '';

        if (item.apenasIda)
          item.apenasIda = 'true'
        else
          item.apenasIda = 'false'

        if (item.despesasExtras)
          item.despesasExtras = "1";

        if (item.projetoAceitarRetirarMercadoria)
          item.projetoAceitarRetirarMercadoria = 'true'
        else
          item.projetoAceitarRetirarMercadoria = 'false'

        let auxPercentualVariacaoFrete = item.percentualVariacaoFrete;
        let auxPercentualVariacaoValor = item.percentualVariacaoValor;


        if (item.projetoAceitarVariacaoPreco)
          item.projetoAceitarVariacaoPreco = 'true'
        else
          item.projetoAceitarVariacaoPreco = 'false'

        if (item.projetoAceitarFrete)
          item.projetoAceitarFrete = 'true'
        else
          item.projetoAceitarFrete = 'false'

        if (auxPercentualVariacaoFrete)
          item.percentualVariacaoFrete = auxPercentualVariacaoFrete.toString();

        if (auxPercentualVariacaoValor)
          item.percentualVariacaoValor = auxPercentualVariacaoValor.toString();

        this.indice = indice;
        this.setDesabilitarExecutora(this.itensSolicitacaoCompra);
        this.itemSolicitacao = item;        
        this.auxIDSubRubrica = item.idSubRubrica;
        this.carregarSubrubricas();
      }
    },
    computed: {
      objetivoCompraContador() {
        let quantidadeCaracteres = this.itemSolicitacao.objetivoCompra ?
          this.itemSolicitacao.objetivoCompra.length : 0;

        return quantidadeCaracteres;
      },
      localAlocadoContador() {
        let quantidadeCaracteres = this.itemSolicitacao.localAlocado ?
          this.itemSolicitacao.localAlocado.length : 0;

        return 500 - quantidadeCaracteres;
      },
      validarTipoCompra() {
        return this.configuracao.solicitacaoUtilizaSelecaoTipoCompra ? 'required' : '';
      },
    },
    mounted() {
      this.$events.on('carregarMetaEtapas', this.carregarMetaEtapas);
      this.$events.on('carregarRubricas', this.carregarRubricas);
        this.listaDeTiposProdutos();
    },
    watch: {
      'itemSolicitacao.tipoCompra': 'alterarProduto',
      'itemSolicitacao.idTipoProduto': 'listaDeProdutos',
    }
  }
</script>

<template>
  <div>
    <div class="row" v-if="configuracao.solicitacaoUtilizaSelecaoTipoCompra">
      <div class="col-xs-12">
        <div class="form-group required" :class="{'has-error': errors.has('tipoCompra')}">
          <label class="control-label" for="tipo-compra">Tipo de Compra</label>

          <select id="tipo-compra"
                  class="form-control"
                  v-model="itemSolicitacao.tipoCompra"
                  v-validate="validarTipoCompra"
                  data-vv-name="tipoCompra"
                  data-vv-as="tipo de compra"
                  :disabled="configuracao.permitirApenasUmTipoItemSolicitacaoCompra && itensSolicitacaoCompra.length > 0">

              <option value="">Selecione...</option>
              <option value="01" v-if="habilitarTipoCompra('01')">Materiais de Consumo</option>
              <option value="04" v-if="habilitarTipoCompra('04')">Livros</option>
              <option value="05" v-if="habilitarTipoCompra('05')">Equipamentos</option>
              <option value="06" v-if="habilitarTipoCompra('06')">Contratação de Serviços</option>
              <option value="06b" v-if="habilitarTipoCompra('06b')">Locação de Veículos</option>
              <option value="09" v-if="habilitarTipoCompra('09')">Reserva de Hotel</option>
              <option value="10" v-if="habilitarTipoCompra('10')">Importação</option>
              <option value="13" v-if="habilitarTipoCompra('13')">Compras Online</option>
              <option value="14" v-if="habilitarTipoCompra('14')">Compras Internas</option>
              <option value="15" v-if="habilitarTipoCompra('15')">Passagem Aérea</option>
          </select>

          <p class="text-danger" v-show="errors.has('tipoCompra')">{{ errors.first('tipoCompra') }}</p>
        </div>
      </div>
    </div>

    <div class="row" v-if="(projeto.utilizarMetaEtapaProjeto === true || configuracao.exibirRubricaSubrubricaSolicitacaoWeb === true || projeto.utilizarRubricaSubrubricaWeb === true) && (itemSolicitacao.tipoCompra !== '' || !configuracao.solicitacaoUtilizaSelecaoTipoCompra)">
      <div class="col-xs-12">
        <div class="form-group">
          <div class="checkbox">
            <checkbox v-model="manterMetaEtapaRubricaSubrubrica" value="1" type="primary">
              Manter meta etapa, rubrica e subrubrica selecionada.
            </checkbox>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-if="projeto.utilizarMetaEtapaProjeto === true && (itemSolicitacao.tipoCompra !== '' || !configuracao.solicitacaoUtilizaSelecaoTipoCompra)">
      <div class="col-xs-12">
        <div class="form-group required" :class="{'has-error': errors.has('metaEtapa')}">
          <label class="control-label" for="meta-etapa">Meta etapa</label>

          <select class="form-control"
                  id="meta-etapa"
                  v-model="itemSolicitacao.idProjetoMetaEtapa"
                  data-vv-name="metaEtapa"
                  data-vv-as="meta etapa"
                  v-validate="'required'"
                  @change="carregarRubricas(projeto.idProjeto)">
            <option value="">Selecione...</option>
            <option :value="metaEtapa.idProjetoMetaEtapa"
                    v-for="(metaEtapa, index) in metaEtapas">
              {{ `${metaEtapa.meta.nome} - ${metaEtapa.etapa.nome}` }}
            </option>
          </select>

          <p class="text-danger" v-show="errors.has('metaEtapa')">{{ errors.first('metaEtapa') }}</p>
        </div>
      </div>
    </div>

    <div class="row" v-if="(configuracao.exibirRubricaSubrubricaSolicitacaoWeb === true || projeto.utilizarRubricaSubrubricaWeb === true) && (itemSolicitacao.tipoCompra !== '' || !configuracao.solicitacaoUtilizaSelecaoTipoCompra)">
      <div class="col-md-6">
        <div class="form-group required" :class="{'has-error': errors.has('rubrica')}">
          <label class="control-label" for="rubrica">Rubrica</label>

          <select class="form-control"
                  id="rubrica"
                  v-model="itemSolicitacao.idRubrica"
                  data-vv-name="rubrica"
                  data-vv-as="rubrica"
                  v-validate="'required'"
                  @change="carregarSubrubricas">
            <option value="">Selecione...</option>
            <option :value="rubrica.id"
                    v-for="rubrica in rubricas">
              {{ rubrica.nome }}
            </option>
          </select>

          <p class="text-danger" v-show="errors.has('rubrica')">{{ errors.first('rubrica') }}</p>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group required" :class="{'has-error': errors.has('subrubrica')}">
          <label class="control-label" for="subrubrica">Subrubrica</label>

          <select class="form-control"
                  id="subrubrica"
                  v-model="itemSolicitacao.idSubrubrica"
                  data-vv-name="subrubrica"
                  data-vv-as="subrubrica"
                  v-validate="'required'">
            <option value="">Selecione...</option>
            <option :value="subrubrica.id"
                    v-for="subrubrica in subrubricas">
              {{ subrubrica.nome }}
            </option>
          </select>

          <p class="text-danger" v-show="errors.has('subrubrica')">{{ errors.first('subrubrica') }}</p>
        </div>
      </div>
    </div>

    <materiais-de-consumo ref="materiaisDeConsumo"
                          :item-solicitacao.sync="itemSolicitacao"
                          :manter-observacao.sync="manterObservacao"
                          :produtos="produtos"
                          :tiposProdutos="tiposProdutos"
                          v-if="itemSolicitacao.tipoCompra === '01' || !configuracao.solicitacaoUtilizaSelecaoTipoCompra">
    </materiais-de-consumo>

    <livros ref="livros"
            :item-solicitacao.sync="itemSolicitacao"
            :manter-observacao.sync="manterObservacao"
            :produtos="produtos"
            :tiposProdutos="tiposProdutos"
            v-if="itemSolicitacao.tipoCompra === '04'">
    </livros>

    <equipamentos ref="equipamentos"
                  :item-solicitacao.sync="itemSolicitacao"
                  :manter-observacao.sync="manterObservacao"
                  :produtos="produtos"
                  :tiposProdutos="tiposProdutos"
                  v-if="itemSolicitacao.tipoCompra === '05'">
    </equipamentos>

    <contratacao-de-servicos ref="contratacaoDeServicos"
                             :item-solicitacao.sync="itemSolicitacao"
                             :manter-observacao.sync="manterObservacao"
                             :produtos="produtos"
                             :tiposProdutos="tiposProdutos"
                             v-if="itemSolicitacao.tipoCompra === '06'">
    </contratacao-de-servicos>

    <locacao-de-veiculos ref="locacaoDeVeiculos"
                         :item-solicitacao.sync="itemSolicitacao"
                         :manter-observacao.sync="manterObservacao"
                         :produtos="produtos"
                         :tiposProdutos="tiposProdutos"
                         v-if="itemSolicitacao.tipoCompra === '06b'">
    </locacao-de-veiculos>

    <reserva-de-hotel ref="reservaDeHotel"
                      :item-solicitacao.sync="itemSolicitacao"
                      :manter-observacao.sync="manterObservacao"
                      :produtos="produtos"
                      :tiposProdutos="tiposProdutos"
                      v-if="itemSolicitacao.tipoCompra === '09'">
    </reserva-de-hotel>

    <importacao ref="importacao"
                :item-solicitacao.sync="itemSolicitacao"
                :manter-observacao.sync="manterObservacao"
                :produtos="produtos"
                :tiposProdutos="tiposProdutos"
                v-if="itemSolicitacao.tipoCompra === '10'">
    </importacao>

    <compras-online ref="comprasOnline"
                    :item-solicitacao.sync="itemSolicitacao"
                    :manter-observacao.sync="manterObservacao"
                    :desabilitarExecutora.sync="desabilitarExecutora"
                    :indice.sync="indice"
                    :produtos="produtos"
                    :tiposProdutos="tiposProdutos"
                    v-if="itemSolicitacao.tipoCompra === '13'">
    </compras-online>

    <compras-internas ref="comprasInternas"
                          :item-solicitacao.sync="itemSolicitacao"
                          :manter-observacao.sync="manterObservacao"
                          :produtos="produtos"
                          :tiposProdutos="tiposProdutos"
                          v-if="itemSolicitacao.tipoCompra === '14'">
    </compras-internas>

    <passagem-aerea ref="passagemAerea"
                    :item-solicitacao.sync="itemSolicitacao"
                    :manter-observacao.sync="manterObservacao"
                    :produtos="produtos"
                    :tiposProdutos="tiposProdutos"
                    v-if="itemSolicitacao.tipoCompra === '15'">
    </passagem-aerea>

    <div v-show="itemSolicitacao.tipoCompra !== '' || !configuracao.solicitacaoUtilizaSelecaoTipoCompra">
      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <div class="checkbox">
              <checkbox v-model="manterJustificativa" value="1" type="primary">
                Manter objetivo da compra (caso esta solicitação
                demandar outros itens com a mesma justificativa)
              </checkbox>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="form-group" :class="{'has-error': errors.has('justificativaCompra'), 'required': configuracao.justificativaCompraObrigatorio}">
            <label class="control-label" for="objetivo-compra">Objetivo/Justificativa da compra ({{ objetivoCompraContador }})</label>

            <textarea class="form-control"
                      id="objetivo-compra"
                      v-model="itemSolicitacao.objetivoCompra"
                      data-vv-name="justificativaCompra"
                      data-vv-as="Objetivo/Justificativa da compra"
                      v-validate="`${configuracao.justificativaCompraObrigatorio ? 'required' : ''}`">
            </textarea>

            <p class="text-danger" v-show="errors.has('justificativaCompra')">{{ errors.first('justificativaCompra') }}</p>
          </div>
        </div>
      </div>

      <div class="row" v-if="itemSolicitacao.tipoCompra === '' || itemSolicitacao.tipoCompra === '01' || itemSolicitacao.tipoCompra === '04' || itemSolicitacao.tipoCompra === '06'">
        <div class="col-xs-12">
          <div class="form-group">
            <div class="checkbox">
              <checkbox v-model="manterLocalAlocado" type="primary">
                {{
                                itemSolicitacao.tipoCompra === '06' ?
                                `Manter local que a prestação do serviço será executada (caso esta solicitação
                                demande outros serviços que serão executados no mesmo local)` :
                                `Manter local que o material será alocado (caso esta solicitação
                                demande outros itens que serão alocados no mesmo local)`
                }}
              </checkbox>
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-if="itemSolicitacao.tipoCompra === '' || itemSolicitacao.tipoCompra === '01' || itemSolicitacao.tipoCompra === '04' || itemSolicitacao.tipoCompra === '06'">
        <div class="col-xs-12">
          <div class="form-group" :class="{'has-error': errors.has('localAlocado'), 'required': configuracao.obrigatorioLocalAlocadoSolCompras}">
            <label class="control-label" for="local-alocado">
              {{
                            itemSolicitacao.tipoCompra === '06' ?
                            'Local da prestação de serviço' :
                            'Local que o material será alocado'
              }}
              ({{ localAlocadoContador }})
            </label>

            <textarea class="form-control"
                      id="local-alocado"
                      v-model="itemSolicitacao.localAlocado"
                      data-vv-name="localAlocado"
                      data-vv-as="local"
                      v-validate="`${configuracao.obrigatorioLocalAlocadoSolCompras ? 'required' : ''}`"
                      maxlength="500">
              
            <p class="text-danger" v-show="errors.has('localAlocado')">{{ errors.first('localAlocado') }}</p>
        </textarea>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <button type="button" class="btn btn-success" @click="validar">
              <i class="fa fa-plus"></i>
              Adicionar/Alterar item
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-compra/componentes/compartilhado/FormAdicionarItem.vue